// @flow
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import Accounts from '../Accounts';
import {actions as AccountsAction} from '../duck';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';

export default connect(
  (state: RootState) => ({
    store: state.store.store,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...AccountsAction,
      },
      dispatch
    )
)(Accounts);
